import { theme } from '../theme';
import { tokens as TypographyTokens } from '../Typography/tokens';
export const SELECTED_STATE_ATTRIBUTE = 'data-selected';
export const DISABLED_STATE_ATTRIBUTE = 'data-disabled';
export const tokens = {
    Wrapper: {
        padding: `${theme.spaces.x2} ${theme.spaces.x8}`
    },
    Content: {
        gap: theme.spaces.x4,
        background: theme.colors.white,
        shadow: theme.shadows.lg,
        borderRadius: theme.radius.x8,
        zIndex: theme.zLayer.xxl,
        borderColor: theme.colors.gray200
    },
    Label: {
        fontFamily: TypographyTokens.Text.fontFamily,
        fontSize: TypographyTokens.Text.level.xs.fontSize,
        fontWeight: theme.fontWeight.medium,
        lineHeight: TypographyTokens.Text.level.xs.lineHeight,
        letterSpacing: TypographyTokens.Text.letterSpacing,
        padding: `${theme.spaces.x6} ${theme.spaces.x8}`,
        color: theme.colors.gray500
    },
    size: {
        lg: {
            padding: `${theme.spaces.x10} ${theme.spaces.x8}`
        },
        md: {
            padding: `${theme.spaces.x6} ${theme.spaces.x8}`
        }
    },
    Separator: {
        height: theme.spaces.x1,
        backgroundColor: theme.colors.gray200,
        margin: theme.spaces.x4
    },
    Item: {
        fontFamily: TypographyTokens.Text.fontFamily,
        fontSize: TypographyTokens.Text.level.sm.fontSize,
        fontWeight: TypographyTokens.Text.fontWeight,
        lineHeight: TypographyTokens.Text.level.sm.lineHeight,
        letterSpacing: TypographyTokens.Text.letterSpacing,
        borderRadius: theme.radius.x4,
        color: theme.colors.gray900,
        iconColor: theme.colors.gray700,
        borderStyle: 'solid',
        state: {
            hovered: {
                background: theme.colors.gray50
            },
            selected: {
                background: theme.colors.gray100
            },
            disabled: {
                color: theme.colors.gray300,
                iconColor: theme.colors.gray200
            },
            dragging: {
                background: theme.colors.gray100,
                borderColor: theme.colors.gray300,
                boxShadow: theme.shadows.md
            },
            draggingStarted: {
                borderColor: theme.colors.gray300,
                color: theme.colors.gray500
            }
        }
    },
    SubMenu: {
        Arrow: {
            gap: theme.spaces.x6
        }
    }
};
